export enum Product {
  ChatBot = 'ChatBot',
  HelpDesk = 'HelpDesk',
  KnowledgeBase = 'KnowledgeBase',
  LiveChat = 'LiveChat',
  Accounts = 'Accounts',
  TextApp = 'TextApp',
}
